module.exports = __webpack_public_path__ + "static/media/jayden.419bdd40.jpeg";